document.addEventListener("DOMContentLoaded", function () {

	//get all fluent buttons
	let ff_buttons = document.getElementsByClassName('ff-btn');

	//if we have some fluent buttons
	if(ff_buttons && ff_buttons.length > 0) {

		//loop over them
		for(let i = 0; i < ff_buttons.length; i++) {

			//add an inner span to their text contents
			ff_buttons[i].innerHTML = '<span class="relative z-1">' + ff_buttons[i].innerHTML + '</span>';
		}
	}

	document.addEventListener('click', function (event) {

		//if the clicked element is a careers application trigger
		if (event.target.classList.contains('apply-role')) {
			event.preventDefault();

			//attempt to get our list of fluent forms
			let fluent_forms = document.getElementsByClassName('fluentform ');

			//if we have some forms
			if(fluent_forms && fluent_forms.length > 0) {

				//scroll to the first one
				((fluent_forms[0]).parentNode).scrollIntoView();
			}
		}
	}, false);
});